import { useState, useEffect } from 'react';

/**
 * A generic hook that returns a debounced value after `delay` milliseconds.
 * Use this whenever you only want to react to `value` changes if
 * there has been no change for `delay` ms.
 */
export function useDebounce<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    // If value changes within the delay, clear and reset the timer
    return () => {
      clearTimeout(timer);
    };
  }, [value, delay]);

  return debouncedValue;
}
